import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Trophy, MapPin } from "lucide-react";
import { setPageMeta } from "@/lib/seo";

export default function TopHub() {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/cities/top", { params: { limit: 250 } })
      .then(({ data }) => setCities(data))
      .catch(() => setCities([]))
      .finally(() => setLoading(false));
    // SEO meta
    setPageMeta({
      title: "Migliori scuole dell'infanzia per città — Per manina",
      description: "Sfoglia le classifiche delle scuole dell'infanzia più amate città per città. Esperienze reali di genitori italiani su oltre 21.000 scuole censite.",
      canonicalPath: "/migliori",
    });
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="max-w-3xl">
        <p className="label-eyebrow text-[#C05C45]">Classifiche</p>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl tracking-tight text-[#1A362D]">
          Le migliori scuole dell'infanzia, città per città
        </h1>
        <p className="mt-4 font-ui text-[#5C6B64] leading-relaxed">
          Le classifiche sono ordinate sulla valutazione media lasciata dai genitori della community. Scegli la tua città
          e scopri le scuole dell'infanzia più amate.
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="top-hub-cities">
        {loading ? (
          [1,2,3,4,5,6].map((i) => <div key={i} className="card-surface h-24 animate-pulse" />)
        ) : (
          cities.map((c) => (
            <Link
              key={c.slug}
              to={`/migliori/${c.slug}`}
              data-testid={`top-city-${c.slug}`}
              className="card-surface p-5 hover:border-[#C05C45] transition-colors group"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-2">
                  <Trophy size={16} className="text-[#E19A32]" />
                  <span className="font-display text-2xl text-[#1A362D] group-hover:text-[#C05C45] transition-colors">{c.city}</span>
                </div>
                {c.reviewed_schools > 0 && (
                  <span className="text-xs font-ui text-white bg-[#C05C45] px-2 py-0.5 rounded">{c.reviewed_schools} raccontate</span>
                )}
              </div>
              <p className="mt-2 font-ui text-xs text-[#5C6B64] flex items-center gap-1">
                <MapPin size={11} /> {c.province} • {c.schools.toLocaleString("it-IT")} scuole
              </p>
            </Link>
          ))
        )}
      </div>
    </div>
  );
}
